'use client';

import type { ReactNode } from 'react';
import { useBottomBarOffset } from '@/lib/hooks/useBottomBarOffset';

/** A bar fixed to the bottom of the screen that tells notifications how tall it is. */
export default function BottomBar({ className, children }: { className: string; children: ReactNode }) {
  const ref = useBottomBarOffset<HTMLDivElement>();
  return <div ref={ref} className={className}>{children}</div>;
}
